<script setup lang="ts">
import "bootstrap/dist/css/bootstrap.min.css";
import { RouteRecordName, RouterView, useRouter } from "vue-router";
import Header from "./components/Header.vue";
import Footer from "./components/Footer.vue";
import { AffiliateVisitPixel } from "./components/pixels";
import { computed } from "vue";

const router = useRouter();
const urlsWithIframeCompatibility: Array<RouteRecordName | null | undefined> = ["quick_quote_calculator"];
const iframeCompatibility = computed(() => {
    return urlsWithIframeCompatibility.includes(
        router.currentRoute.value.name,
    );
});
</script>

<template>
    <Header v-if="!iframeCompatibility" />
    <main
        id="app"
        class="container"
    >
        <RouterView />
    </main>
    <Footer v-if="!iframeCompatibility" />
    <AffiliateVisitPixel v-if="!iframeCompatibility" />
</template>
<style>
</style>
